import React, {useEffect, useState, useMemo, useCallback} from 'react'
import { Text } from 'rebass'
import styled from 'styled-components'
import { provider } from 'web3-core'
import { RouteComponentProps } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Contract } from 'web3-eth-contract'
import { Plus } from 'react-feather'
import BigNumber from 'bignumber.js'

// import { BodyTitle } from '../../components/bakery/styleds'
import { ButtonConfirmed } from '../../components/Button'
import { ButtonPrimary } from '../../components/Button'
import DepositModal from './components/DepositModal'
import WithdrawModal from './components/WithdrawModal'
import HarvestModal from './components/HarvestModal'
import Loading from '../../components/Loader/Loading'
import Value from '../../components/Value'
import Popover from './components/Popover'

import { getContract } from '../../utils/bakery/erc20'
import { getBalanceNumber } from '../../utils/bakery/formatBalance'
import {
  getEth2MasterContract,
  getMasterChefContract,
  getAethMasterContract,
  getMasterChef2Contract
} from '../../sushi/utils'

// hooks
import { useWalletModalToggle } from '../../state/application/hooks'
import { useActiveWeb3React } from '../../hooks'
import useYam from '../../hooks/bakery/useYam'
import useFarm from '../../hooks/bakery/useFarm'
import useStake from '../../hooks/bakery/useStake'
import useModal from '../../hooks/bakery/useModal'
import useReward from '../../hooks/bakery/useReward'
import useUnstake from '../../hooks/bakery/useUnstake'
import useApprove from '../../hooks/bakery/useApprove'
import useEthEarning from '../../hooks/bakery/useEthEarning'
import useAllowance from '../../hooks/bakery/useAllowance'
import useTokenBalance from '../../hooks/bakery/useTokenBalance'
import useStakedBalance from '../../hooks/bakery/useStakedBalance'

import { MINTTOKEN } from '../../constants/bakery'

const LoginBtn = styled(ButtonPrimary)`
  margin: 54px auto 0;
  width: initial;
  padding: 8px 16px;
`
const LoginBtnWrapper = styled.div``
const Tips = styled.div`
  font-size:14px;
  color: ${({ theme }) => theme.bsText3 };
  text-align: center;
`
const TipsText = styled(Text)`
  color: ${({ theme }) => theme.bsText7 };
  text-align: center;
  padding-top: 16px;
`
const TitleText = styled(Text)`
  font-family: Baloo Da;
  color: ${({ theme }) => theme.bsText4};
  font-size: 30px;
`
const Content = styled.div`
  margin-top: 50px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`
const activeTWOClassName = 'TWOACTIVENAV'
const activeTHEClassName = 'THEACTIVENAV'
const CardLeft = styled.div.attrs({activeTWOClassName, activeTHEClassName})`
  display: flex;
  flex-wrap: wrap;
  background-color: ${({ theme }) => theme.bg1 };
  min-height: 296px;
  border-radius: 20px;
  box-shadow: 0px 2px 10px rgba(171, 133, 115, 0.16);
  padding: 23px 10px;
  margin-bottom: 40px;
  margin-right: 25px;
  &.${activeTWOClassName} {
    width: 426px;
    & > div {
      width: 50%;
    }
  }
  &.${activeTHEClassName} {
    width: 454px;
    & > div {
      width: 33.3%;
    }
  }
  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-right: 0px;
    &.${activeTWOClassName} {
      width: 100%;
    }
    &.${activeTHEClassName} {
      width: 100%;
    }
  `};
`
const CardRight = styled.div`
  text-align: center;
  background-color: ${({ theme }) => theme.bg1 };
  /* background-image: url('/images/bakery/icon_hamburger_card_bg.svg'); */
  background-position-x: 60px;
  background-position-y: -50px;
  background-repeat: no-repeat;
  border-radius: 20px;
  box-shadow: 0px 2px 10px rgba(171, 133, 115, 0.16);
  padding: 24px;
  min-width: 298px;
  height: 296px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    flex: 1;
  `};
`
const Left = styled.div`
  min-height: 250px;
  padding-top: 11px;
  flex-grow: 1;
  text-align: center;
  position: relative;
`
const BorderBox = styled.div<{ right?: boolean }>`
  border-right: ${({ right }) => right ? 'none' : '1px dashed #D6A485;'};
  ${({ theme }) => theme.mediaWidth.upToSmall`
    border-right: 0px;
  `};
`
const HarvestBtn = styled(ButtonConfirmed)`
  width: 80%;
  height: 48px;
  margin: 0 auto;
  margin-top: 40px;
  font-size: 14px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  /* overflow: hidden; */
`
const IconImg = styled.img`
  margin-bottom: 15px;
`
const BtnBox = styled.div`
  display: flex;
  margin-top: 30px ;
`
const Button = styled(ButtonConfirmed)`
  border: none;
  font-size: 14px;
  width: 100%;
  height: 48px;
  padding: 0;
`
const AddBtn = styled(ButtonPrimary)`
  flex-shrink: 0;
  font-family: Baloo Da;
  width: 48px;
  height: 48px;
  margin-left: 16px;
  padding: 0;
`
const StyledPlusIcon = styled(Plus)`
  height: 20px;
  width: 20px;

  > * {
    stroke: ${({ theme }) => theme.primaryText1};
  }
`  


export default function Eth2Child ({
  match: {
    params: {earn, bakeryId}
  },
  history
}: RouteComponentProps<{earn?: string, bakeryId?: string}>) {
  const [harvstModalVisible, setHarvstModalVisible] = useState(false)
  const [loadingFlag, setLoadingFlag] = useState(true)
  const { active, account, library } = useActiveWeb3React()
  const { t } = useTranslation()
  const sushi = useYam()
  const toggleWalletModal = useWalletModalToggle()
  const ethereum = library?.provider

  const {
    pid,
    lpToken,
    lpTokenAddress,
    earnToken,
    icon,
    otherName,
    stakeIcon,
  } = useFarm(bakeryId, earn) || {
    pid: 0,
    lpToken: '',
    lpTokenAddress: '',
    tokenAddress: '',
    earnToken: '',
    name: '',
    icon: '',
    activityTime: '',
    stakeIcon: '',
    otherName: ''
  }
  const [pendingHt, setPendingHt] = useState(false)
  const lpTokenName = lpToken.toUpperCase()
  const earnTokenName = earnToken.toUpperCase()
  const BETHTOKEN = 'BETH'
  const ONXTOKEN = 'ONX'
  const ANKRTOKEN = 'ANKR'
  const BAKETOKEN = 'BAKE'

  const lpContract = useMemo(() => {
    return getContract(ethereum as provider, lpTokenAddress)
  }, [ethereum, lpTokenAddress])


  useEffect(() => {
    if (!pid || !earn || [MINTTOKEN.ETH2MASTER, MINTTOKEN.AETHMASTER].indexOf(earn) < 0) {
      history.push(`/eth2`)
    }
  }, [earn, pid, history])


  let masterContract: Contract
  switch (earnTokenName) {
    case MINTTOKEN.ETH2MASTER:
      masterContract = getEth2MasterContract(sushi)
      break
    case MINTTOKEN.AETHMASTER:
      masterContract = getAethMasterContract(sushi)
      break
    case MINTTOKEN.BAKEV2:
      masterContract = getMasterChef2Contract(sushi)
      break
    default:
      masterContract = getMasterChefContract(sushi)
  }

  const pendingTx = false
  // const [pendingTx, setPendingTx] = useState(false)
  const earnings = useEthEarning(lpTokenAddress, earnTokenName)
  const { onReward } = useReward(lpTokenAddress, earnTokenName)
  
  useEffect(() => {
    if (earnings) {
      setLoadingFlag(false)
    }
  }, [earnings])
  
  const [requestedApproval, setRequestedApproval] = useState(false)
  const { onApprove } = useApprove(lpContract, masterContract)
  const allowance = useAllowance(lpContract, masterContract)
  const tokenBalance = useTokenBalance(lpContract.options.address)
  const stakedBalance = useStakedBalance(lpTokenAddress, masterContract)
  const { onStake } = useStake(lpTokenAddress, masterContract)
  const { onUnstake } = useUnstake(lpTokenAddress, masterContract)
  const [onPresentDeposit] = useModal(
    <DepositModal 
      max={tokenBalance} 
      onConfirm={onStake} 
      tokenName={lpTokenName} 
    />)
  const [onPresentWithdraw] = useModal(
    <WithdrawModal
      max={stakedBalance}
      onConfirm={onUnstake}
      tokenName={lpTokenName}
    />,
  )
  const handleApprove = useCallback(async () => {
    try {
      setRequestedApproval(true)
      const txHash = await onApprove()
      // user rejected tx or didn't go thru
      if (!txHash) {
        setRequestedApproval(false)
      }
    } catch (e) {
      console.log(e)
    }
  }, [onApprove, setRequestedApproval])

  // const onRewardEarn = (tokenName: any) => {
  //   setLoadingFlag(true)
  //   setPendingTx(true)
  //   onReward(tokenName)
  //     .finally(() => {
  //       setLoadingFlag(false)
  //       setPendingTx(false)
  //     })
  // }

  const [harvestTokenName, setTokenName] = useState('')
  const [harvestTokenNum, setTokenNum] = useState(new BigNumber(0))
  const [harvestBakeNum, setBakeNum] = useState(new BigNumber(0))

  const handHarvestToken = (tokenName: any, tokenNum: any, bakeNum: any) => {
    setTokenName(tokenName)
    setTokenNum(tokenNum)
    setBakeNum(bakeNum)
    setHarvstModalVisible(true)
  }

  return (
    <>
      <HarvestModal
        isOpen={harvstModalVisible}
        onDismiss={()=>{setHarvstModalVisible(false)}}
        tokenNum={ harvestTokenNum }
        tokenName={ harvestTokenName }
        bakeNum={ harvestBakeNum }
        onConfirm={(name: any) => onReward(name)}
      />

      <Loading open={loadingFlag} />

      {!(active && account) 
      ? 
        <LoginBtnWrapper>
          <LoginBtn onClick={toggleWalletModal}>{t('Connect to a wallet')}</LoginBtn>
        </LoginBtnWrapper>
      : 
        <>
          <img height={102} src={'/images/bakery/icon_'+ icon +'_card.svg'} alt=""/>
          {/* <BodyTitle fontSize={32} fontWeight={700}>
            ETH2.0
          </BodyTitle> */}
          <TipsText fontSize={20} fontWeight={700}>{`Stake ${lpTokenName} Tokens and earn ${otherName}`}</TipsText>
          <Content>
            {
              earnings 
              ? <CardLeft className={earnTokenName === MINTTOKEN.ETH2MASTER ? activeTWOClassName : activeTHEClassName}>
                  {
                    [MINTTOKEN.ETH2MASTER].includes(earnTokenName) &&
                    <Left>
                      <BorderBox right={true}>
                        {
                          [MINTTOKEN.ETH2MASTER].includes(earnTokenName)
                           ? <img width={72} src={'/images/bakery/icon_' + otherName.toLocaleLowerCase() + '.svg'} alt=""/>
                           : <img width={72} src={'/images/bakery/icon_' + stakeIcon + '.svg'} alt=""/>
                        }
                        <TitleText>
                          <Value value={getBalanceNumber(new BigNumber(earnings.bakeReward).plus(new BigNumber(earnings.convertToBakeReward)))} />
                        </TitleText>
                        {
                          ![MINTTOKEN.ETH2MASTER].includes(earnTokenName)
                          ? <Tips>{BETHTOKEN.toLocaleUpperCase()} rewards are distributed once daily</Tips>
                          : <Tips>{ otherName } Earned</Tips>
                        }
                      </BorderBox>
                      {
                        ![MINTTOKEN.ETH2MASTER].includes(earnTokenName)
                        ? <HarvestBtn 
                            disabled={!earnings.tokenReward.toNumber()}
                            onClick={() => handHarvestToken(BETHTOKEN, earnings.tokenRewardNow, new BigNumber(earnings.bakeReward).plus(new BigNumber(earnings.convertToBakeReward)))}
                          >
                            Harvest
                            <Popover tokeName={BETHTOKEN}>
                            </Popover>
                          </HarvestBtn>
                        : <HarvestBtn 
                            disabled={pendingHt || !getBalanceNumber(new BigNumber(earnings.bakeReward).plus(new BigNumber(earnings.convertToBakeReward)))}
                            onClick={async () => {
                              setPendingHt(true)
                              const txHash = await onReward(BETHTOKEN.toLowerCase())
                              txHash && await onReward(BAKETOKEN.toLowerCase())
                              setPendingHt(false)
                            }}
                          >
                            <Text fontSize={14} fontWeight={700}>{pendingHt ? 'Collecting ' + (otherName|| earnTokenName) : 'Harvest'}</Text>
                          </HarvestBtn>
                      }
                    </Left>
                  }
                  {
                    [MINTTOKEN.AETHMASTER].includes(earnTokenName) &&
                    <>
                      <Left>
                        <BorderBox>
                          <img width={72} src="/images/bakery/icon_ankr.svg" alt=""/>
                          <TitleText>
                            <Value value={getBalanceNumber(earnings.ankrReward)} />
                          </TitleText>
                          <Tips>Ankr Earned</Tips>
                        </BorderBox>
                        <HarvestBtn 
                          disabled={ !earnings.ankrReward.toNumber() || pendingTx}
                          onClick={() => handHarvestToken(ANKRTOKEN, earnings.ankrRewardNow, earnings.ankrConvertToBakeRewards)}
                        >Harvest
                          <Popover tokeName={ANKRTOKEN}>
                          </Popover>
                        </HarvestBtn>
                      </Left>
                      
                      <Left>
                        <img width={72} src="/images/bakery/icon_onx.svg" alt=""/>
                        <TitleText>
                          <Value value={getBalanceNumber(earnings.onxReward)} />
                        </TitleText>
                        <Tips>{ONXTOKEN} Earned</Tips>
                        <HarvestBtn 
                          disabled={ !earnings.onxReward.toNumber() || pendingTx}
                          onClick={() => handHarvestToken(ONXTOKEN, earnings.onxRewardNow, earnings.onxConvertToBakeRewards)}
                        >Harvest
                          <Popover tokeName={ONXTOKEN}>
                          </Popover>
                        </HarvestBtn>
                      </Left>
                    </>
                  }
                  {/* <Left>
                    <img width={72} src="/images/bakery/icon_doughnut.svg" alt=""/>
                    <TitleText>
                      <Value value={getBalanceNumber(earnings.bakeReward)} />
                    </TitleText>
                    <Tips>BAKE Earned</Tips>
                    <HarvestBtn 
                      disabled={ !earnings.bakeReward.toNumber() || pendingTx}
                      onClick={() => onRewardEarn('bake')}
                    >Harvest</HarvestBtn>
                  </Left> */}
                </CardLeft>
              : null
            }
            <CardRight style={{ backgroundImage: 'url(/images/bakery/icon_' + icon + '_card_bg.svg)' }}>
              <IconImg height={68} src={'/images/bakery/icon_'+ icon +'_card.svg'}></IconImg>
              <TitleText fontSize={36}>
                <Value value={getBalanceNumber(stakedBalance)} />
              </TitleText>
              <Tips>{`${lpTokenName} Tokens Staked`}</Tips>
              {
                !allowance.toNumber() 
                ? 
                <BtnBox>
                  <Button disabled={requestedApproval} onClick={handleApprove}>{`Approve ${lpTokenName}`}</Button>
                </BtnBox>
                : 
                <BtnBox>
                  <Button disabled={stakedBalance.eq(new BigNumber(0))} onClick={onPresentWithdraw}>Unstake</Button>
                  <AddBtn onClick={onPresentDeposit}>
                    <StyledPlusIcon/>
                  </AddBtn>
                </BtnBox>
              }
            </CardRight>
          </Content>
        </>
      }
    </>
  )
}